export function LoadingComponent() {
  return (
    <div className="flex items-center justify-center h-screen bg-white">
      <div className="flex items-center justify-center space-x-2 animate-pulse">
        <div className="w-8 h-8 bg-pink-400 rounded-full"></div>
        <div className="w-8 h-8 bg-pink-500 rounded-full"></div>
        <div className="w-8 h-8 bg-pink-600 rounded-full"></div>
      </div>
    </div>
  );
}
